import React from "react";
import { Link, useNavigate } from "react-router-dom";

import { BsArrowLeft } from "react-icons/bs";

import "./NavigationHeader.scss";
import useActivePath from "../../CustomHooks/useActivePath";

export default function NavigationHeader() {
  const { urlPaths } = useActivePath();
  const navigate = useNavigate();

  // const renderLinks = () => {
  //   let navLinks = [];
  //   for (let index = 1; index < 2; index++) {
  //     navLinks.push(
  //       <li className="nav_item" key={index}>
  //         <Link to={`/${urlPaths[index]}`} className="nav_link">
  //           {urlPaths[index]}
  //         </Link>
  //       </li>
  //     );
  //   }
  //   return navLinks;
  // };

  return (
    <div className="navigation_header_container">
      <div className="nav_item" onClick={() => navigate("../")}>
        <Link to="#" className="nav_link">
          <BsArrowLeft />
        </Link>
      </div>
      {/* <ul>
        <li className="nav_item">
          <Link to={"/"} className="nav_link">
            Home
          </Link>
        </li>
        {renderLinks()}
      </ul> */}
    </div>
  );
}
